import React from "react";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion as MuiAccordion } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import { styles } from "./styles";

const Accordion = (props) => {
  const { children, classes, index, title, secondaryTitle } = props;

  return (
    <MuiAccordion className={classes.accordion} square={false}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index}a-content`}
        id={`panel${index}a-header`}
      >
        <div className={classes.heading}>
          <Typography className={classes.primaryHeading}>{title}</Typography>
          <Typography className={classes.secondaryHeading}>{secondaryTitle}</Typography>
        </div>
      </AccordionSummary>

      <AccordionDetails className={classes.accordionContent}>{children}</AccordionDetails>
    </MuiAccordion>
  );
};

export default withStyles(styles)(Accordion);
